import { useMediaQuery, Container, Box, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  messageBox: {
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(4),
    },
    textAlign: "center",
  },
  messageText: {
    display: "flex",
    justifyContent: "center",
  },
}));

const BookingContainer = ({
  title,
  children,
  isMediumContainerWanted = false,
  message = undefined,
}) => {
  const isSmallScreen = useMediaQuery((x) => x.breakpoints.down("sm"));
  const classes = useStyles({ message });

  return (
    <Container maxWidth={isMediumContainerWanted ? "md" : "sm"}>
      <div className="flex flex-col items-center justify-center w-xl">
        {title && (
          <Box mb={1} className="text-center mb-10 mt-16">
            <p className="flex justify-center h3">{title}</p>
          </Box>
        )}
        {message && (
          <Box mb={1} className={classes.messageBox}>
            <Typography
              variant={isSmallScreen ? "h4" : "h3"}
              className={classes.messageText}
            >
              {message}
            </Typography>
          </Box>
        )}
      </div>
      {children}
    </Container>
  );
};

export default BookingContainer;
